import { AxiosError, isAxiosError } from 'axios';

interface ITurnstileVerificationResponse {
  message?: string;
  error?: string;
  errorCode?: string;
}

const INVALID_TURNSTILE_TOKEN = 'INVALID_TURNSTILE_TOKEN';

export class TurnstileVerificationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TurnstileVerificationError';
  }

  static fromAxiosError(error: unknown): TurnstileVerificationError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<ITurnstileVerificationResponse>;
    const data = axiosError.response?.data;

    if (String(data?.errorCode || '') === INVALID_TURNSTILE_TOKEN) {
      const message =
        data?.message || data?.error || 'Please complete the verification and try again.';
      return new TurnstileVerificationError(message);
    }

    return null;
  }
}
